<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-09-18 09:13:30
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-09-26 17:06:12
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/home/workbench/components/expressFastRoute.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div>
    <ul class="route-wrap">
      <li
        v-for="item in routeInfo"
        :key="item.icons"
        @click="goToPage(item.url, item.type)"
      >
        <div class="route-icon-wrap">
          <eui-icon :icon="item.icons" font-size="24px" />
        </div>
        <p>{{ item.iconName }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { epecMallUrl, oldMallBaseUrl } from '../../../../api/config.js';

export default {
  components: {},
  data() {
    return {
      routeInfo: [
        {
          icons: 'eicon-fahuo',
          iconName: '发货',
          url: '/orderManage',
          type: 'Router',
        },
        {
          icons: 'eicon-shouhuo',
          iconName: '收货',
          url: `${epecMallUrl}/user/user/userOrder`,
          type: 'Link',
        },
        {
          icons: 'eicon-wuliufahuoxunbijia',
          iconName: '物流发货询比价',
          url: 'https://ewuliu.epec.com/',
          type: 'Link',
        },
        {
          icons: 'eicon-fahuodizhiguanli',
          iconName: '发货地址管理',
          url: '/address',
          type: 'Router',
        },
        {
          icons: 'eicon-wuliushangguanli',
          iconName: '物流商管理',
          url: `${oldMallBaseUrl}/ecmall/relationship/queryCompanyTransport.do`,
          type: 'Link',
        },
      ],
    };
  },

  computed: {},

  created() {},
  methods: {
    goToPage(url, type) {
      if (type === 'Link') {
        window.open(url, '_blank');
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.route-wrap {
  display: flex;
  flex-flow: row;
  margin-bottom: 50px;
  li {
    margin-right: 50px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
  }
  .route-icon-wrap {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
  }
  p {
    font-size: 14px;
    color: #333;
    position: absolute;
    width: 100px;
    top: 64px;
  }
}
</style>
